import React, {useEffect, useState} from "react"
import PropTypes from "prop-types";
import Link from "next/link";
const AllResourcesTabV2 = ({ selectedWhitepaper,allResourcesData }) => {
    const [ whitePaper, setWhitePaper ] = useState([])

    let whitepaperData = allResourcesData?.allWhitepaper.edges

    useEffect(() => {
        if(whitepaperData && whitepaperData.length > 0) {
            const _whitepaperData = whitepaperData.filter(i =>
                i.node.id !== selectedWhitepaper.id
            )
            setWhitePaper(_whitepaperData)
        }
    }, [whitepaperData])
    return <>
        <div className={"related-blog"}>
            <div className={"container"}>
                <h2>Related Posts</h2>
                <div className={"d-flex"}>
                    {whitePaper?.length > 0 ? whitePaper.map((__data, index) => {
                        let data = __data.node

                                return <> 
                                    <div className={"blog-card"} key={index}>
                                        <Link href={`${data?.uri}`} itemProp="url">
                                            <img src={data?.featuredImage.node.sourceUrl} alt={data?.title} width={100} height={100}/>
                                        </Link>
                                        <div className={`category ${data.slug}`}>{data.name}</div>
                                        <Link href={`${data?.uri}`} itemProp="url"><h4>{data.title}</h4>
                                        </Link>
                                        <Link href={`${data?.uri}`} className={"read-more"}>Download Whitepaper</Link>
                                    </div>
                                </>
                            }) : <h4>Coming soon</h4>}
                </div>
            </div>
        </div>
    </>
}
AllResourcesTabV2.defaultProps = {}

AllResourcesTabV2.propTypes = {
    selectedWhitepaper: PropTypes.object
}
export default AllResourcesTabV2